import { useRouter } from 'next/router';

/**
 * @deprecated использовать useRouter<IQueryPaymentParams>
 */
export const usePrepareQueryData = (): Record<string, string> => {
    const { query } = useRouter();
    const _query: Record<string, string> = {};

    for (const key in query) {
        const _value = query[key];
        _query[key] = _value ? (typeof _value === 'string' ? _value : _value[0]) : '';
    }

    return _query;
};
